import { render, staticRenderFns } from "./mine.vue?vue&type=template&id=283c2e63&scoped=true&"
import script from "./mine.vue?vue&type=script&lang=js&"
export * from "./mine.vue?vue&type=script&lang=js&"
import style0 from "./mine.vue?vue&type=style&index=0&id=283c2e63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283c2e63",
  null
  
)

export default component.exports